// lib/iban.js
//
// Dieselbe Prüfung wie im Backend (services/bankdaten.js): Format und
// Prüfsumme nach ISO 13616. Nur für den Hinweis im Formular — entscheiden
// tut der Server. Vorher lag sie nur in TurnierBearbeitenPage.jsx.

export function ibanGueltig(wert) {
  const iban = String(wert || '').replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  let rest = 0;
  for (const z of iban.slice(4) + iban.slice(0, 4)) {
    const w = /[A-Z]/.test(z) ? String(z.charCodeAt(0) - 55) : z;
    for (const d of w) rest = (rest * 10 + Number(d)) % 97;
  }
  return rest === 1;
}
